(function() {
    angular.module('emarket.store.categories')
    .controller('StoreCategoryController', ['$state', 'categories', function($state, categories) {
        var vm = this;
        vm.categories = categories;
        vm.onCategoryChoose = function(category) {
            $state.go('store.search', {category: category._id});
        };
    }]);

}());
